import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

export const formatISODate = (isoDateString) => {
  // Create a new Date object from the ISO date string
  const date = new Date(isoDateString)

  // Extract the year, month, and day
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, `0`) // Months are 0-based
  const day = String(date.getDate()).padStart(2, `0`)

  // Format the date as yyyy-mm-dd
  return `${year}-${month}-${day}`
}

export const formatDate = (dateStr) => {
  // Create a Date object from the input date string
  const date = new Date(dateStr)

  // Define an array of month names
  const monthNames = [
    `Jan`,
    `Feb`,
    `Mar`,
    `Apr`,
    `May`,
    `Jun`,
    `Jul`,
    `Aug`,
    `Sep`,
    `Oct`,
    `Nov`,
    `Dec`,
  ]

  // Extract the day, month, and year from the date object
  const day = date.getDate()
  const month = monthNames[date.getMonth()]
  const year = date.getFullYear()

  // Format the date as 'Month Day, Year'
  const formattedDate = `${month} ${day}, ${year}`

  return formattedDate
}

export const formatDateTime = (isoString) => {
  // Create a Date object from the ISO string
  const date = new Date(isoString)

  // Extract year, month, and day
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, `0`)
  const day = String(date.getDate()).padStart(2, `0`)

  // Extract hours, minutes, and seconds
  let hours = date.getHours()
  const minutes = String(date.getMinutes()).padStart(2, `0`)
  const seconds = String(date.getSeconds()).padStart(2, `0`)

  // Determine AM/PM
  const ampm = hours >= 12 ? `PM` : `AM`
  hours = hours % 12
  hours = hours ? hours : 12 // the hour '0' should be '12'
  const formattedHours = String(hours).padStart(2, `0`)

  // Format the date and time
  const formattedDate = `${year}-${month}-${day}`
  const formattedTime = `${formattedHours}:${minutes}:${seconds} ${ampm}`

  return `${formattedDate} ${formattedTime}`
}

//* CONVERT MM_YYYY DATE STRING TO WORDS
export const convertMonthYearToWords = (dateString) => {
  const months = [
    `January`,
    `February`,
    `March`,
    `April`,
    `May`,
    `June`,
    `July`,
    `August`,
    `September`,
    `October`,
    `November`,
    `December`,
  ]

  if (!dateString || typeof dateString !== `string`) {
    return ``
  }

  const [year, month] = dateString.split(`-`)
  const monthIndex = parseInt(month) - 1

  if (monthIndex < 0 || monthIndex > 11 || isNaN(monthIndex)) {
    return `Invalid date format`
  }

  return `${months[monthIndex]} ${year}`
}

//* Function to check if current date is between 1-15 return 1 else 16

export const getStartOrMidOfMonth = () => {
  const today = new Date()
  const day = today.getDate()
  const month = today.getMonth() + 1 // getMonth() returns 0-11, so we add 1 to get 1-12
  const year = today.getFullYear()

  const targetDay = day <= 15 ? 1 : 16
  const targetMonth = month.toString().padStart(2, `0`) // Ensures month is always 2 digits
  const targetDate = `${year}-${targetMonth}-${targetDay
    .toString()
    .padStart(2, `0`)}` // Ensures day is always 2 digits

  return targetDate
}

//$ ================================================================================ $//
//$                          CONVERT YYYY-MM-DD TO 1st Aug 2024
//$ ================================================================================ $//

function addDaySuffix(day) {
  if (day > 3 && day < 21) return `${day}th`
  switch (day % 10) {
    case 1:
      return `${day}st`
    case 2:
      return `${day}nd`
    case 3:
      return `${day}rd`
    default:
      return `${day}th`
  }
}

export function formatCustomDate(dateString) {
  const months = [
    `Jan`,
    `Feb`,
    `Mar`,
    `Apr`,
    `May`,
    `Jun`,
    `Jul`,
    `Aug`,
    `Sep`,
    `Oct`,
    `Nov`,
    `Dec`,
  ]

  const [year, month, day] = dateString?.split(`-`)
  const dayWithSuffix = addDaySuffix(parseInt(day))
  const monthName = months[parseInt(month) - 1]

  return `${dayWithSuffix} ${monthName} ${year}`
}

//* Function to check if current date is between 16-end return 16 else last date

export const getMidOrEndOfMonth = () => {
  const today = new Date()
  const day = today.getDate()
  const month = today.getMonth() + 1 // getMonth() returns 0-11, so we add 1 to get 1-12
  const year = today.getFullYear()

  let targetDay

  if (day <= 15) {
    targetDay = 15
  } else {
    // Get the last day of the month
    const lastDay = new Date(year, month, 0).getDate()
    targetDay = lastDay
  }

  const targetMonth = month.toString().padStart(2, `0`) // Ensures month is always 2 digits
  const targetDate = `${year}-${targetMonth}-${targetDay
    .toString()
    .padStart(2, `0`)}` // Ensures day is always 2 digits

  return targetDate
}

//$ ================================================================================ $//
//$                FORMAT DATE TO (Wed, 02 Oct 2024, 12:24 pm) FORMAT
//$ ================================================================================ $//

export const formatDateToDayMonthYearTime = (isoDate) => {
  return dayjs(isoDate).tz(dayjs.tz.guess()).format('ddd, DD MMM YYYY, hh:mm a')
}
